/**
 * @generated SignedSource<<f1596059bff9a822401494ef182e9944>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoanUpsertInputObject = {
  expectedMonthlySalesCents?: number | null | undefined;
  feeCents?: number | null | undefined;
  handle: string;
  holdbackBps?: number | null | undefined;
  name?: string | null | undefined;
  payoutAccountNumber?: string | null | undefined;
  principalCents?: number | null | undefined;
  repaymentCaseSensitive?: boolean | null | undefined;
  repaymentEndDate?: any | null | undefined;
  repaymentMatchField?: string | null | undefined;
  repaymentMatchKind?: string | null | undefined;
  repaymentMode?: string | null | undefined;
  repaymentPattern?: string | null | undefined;
  source?: string | null | undefined;
  startDate?: any | null | undefined;
  termMonths?: number | null | undefined;
};
export type loansPage_UpsertMutation$variables = {
  input: LoanUpsertInputObject;
};
export type loansPage_UpsertMutation$data = {
  readonly loanUpsert: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly loan: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type loansPage_UpsertMutation = {
  response: loansPage_UpsertMutation$data;
  variables: loansPage_UpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Loan",
  "kind": "LinkedField",
  "name": "loan",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "loansPage_UpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoanUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "loanUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "loansPage_UpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoanUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "loanUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "976423f12204546327eacc0d4de6e762",
    "id": null,
    "metadata": {},
    "name": "loansPage_UpsertMutation",
    "operationKind": "mutation",
    "text": "mutation loansPage_UpsertMutation(\n  $input: LoanUpsertInputObject!\n) {\n  loanUpsert(input: $input) {\n    loan {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c18dda04b7d71a7755c768c5993580c";

export default node;
